module.exports = __webpack_public_path__ + "img/LOGO.d722994e.png";